import { useEffect } from "react";
import { useState } from "react"

const useAllProjects = () =>{
    const [projects, setProjects] = useState([])
    useEffect(()=> {
        fetch('allProjects.json')
        .then(response => response.json())
        .then(data => setProjects(data))
    },[])
    return [projects]
}
export default useAllProjects;